import { useCallback, useState } from 'react';

export const useSelectedMapWithOrder = ({ initialState }: { initialState?: string[] }) => {
  const [selectedMap, setSelectedMap] = useState<{ [key: string]: number }>(
    () => initialState?.reduce((map, key, idx) => ({ ...map, [key]: idx + 1 }), {}) ?? {},
  );
  const onSelect = useCallback(
    (id: string) => {
      setSelectedMap((state) => {
        const newState: { [key: string]: number } = {};
        let idx = 1;
        for (const key in state) {
          if (key !== id) {
            newState[key] = idx;
            idx++;
          }
        }
        if (!(id in state)) {
          newState[id] = idx;
        }
        return newState;
      });
    },
    [setSelectedMap],
  );
  const selectItem = useCallback((id: string) => () => onSelect(id), [onSelect]);

  return { selectedMap, onSelect, selectItem };
};
